(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3d-single-carousel-aa"] && !window.DesignMode) return;
  try {
    
  $('.single_slider').owlCarousel({
            items: 1,
            loop: true,
            center: true,
            lazyLoad: true,
            smartSpeed: 1000,
      autoplay: true,
         autoplayTimeout: 3000,
            autoplayHoverPause: true,
            mouseDrag: false,
       touchDrag: false,
            nav: true,
            dots: false,
          responsiveClass: true,
            navText: ['<span class="fa fa-angle-left"></span>', '<span class="fa fa-angle-right"></span>'],
     responsive:{
       0:{
            autoplayTimeout: 5000,
        },
       767:{
            autoplayTimeout: 3000,
        },
    }
        })
   // smokee effect
var canvas = document.getElementById('smokee');
var ctx = canvas.getContext('2d');
canvas.width = innerWidth;
canvas.height = innerHeight;

var party = smokemachine(ctx, [255, 255, 255]);
party.start(); // start animating

party.setPreDrawCallback(function(dt) {
    // Check if the screen is mobile-sized
    var isMobile = window.innerWidth <= 768; // Adjust 768 as needed for your breakpoints
    var smokeAmount = isMobile ? 0.03 : 0.1; // Use a smaller amount for mobile

    // Add smoke with the adjusted amount
    party.addSmoke(innerWidth / 2, innerHeight, smokeAmount);

    // Ensure the canvas adjusts to window size changes
    canvas.width = innerWidth;
    canvas.height = innerHeight;
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["3d-single-carousel"] && !window.DesignMode) return;
  try {
    
  $('.single_slider').owlCarousel({
            items: 1,
            loop: true,
            center: true,
            lazyLoad: true,
            smartSpeed: 1000,
      autoplay: true,
         autoplayTimeout: 3000,
            autoplayHoverPause: true,
            mouseDrag: false,
       touchDrag: false,
            nav: true,
            dots: false,
          responsiveClass: true,
            navText: ['<span class="fa fa-angle-left"></span>', '<span class="fa fa-angle-right"></span>'],
     responsive:{
       0:{
            autoplayTimeout: 5000,
        },
       767:{
            autoplayTimeout: 3000,
        },
    }
        })
   // smokee effect
var canvas = document.getElementById('smokee');
var ctx = canvas.getContext('2d');
canvas.width = innerWidth;
canvas.height = innerHeight;

var party = smokemachine(ctx, [255, 255, 255]);
party.start(); // start animating

party.setPreDrawCallback(function(dt) {
    // Check if the screen is mobile-sized
    var isMobile = window.innerWidth <= 768; // Adjust 768 as needed for your breakpoints
    var smokeAmount = isMobile ? 0.03 : 0.1; // Use a smaller amount for mobile

    // Add smoke with the adjusted amount
    party.addSmoke(innerWidth / 2, innerHeight, smokeAmount);

    // Ensure the canvas adjusts to window size changes
    canvas.width = innerWidth;
    canvas.height = innerHeight;
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["battery-with-boxes"] && !window.DesignMode) return;
  try {
    
// gsap.registerPlugin(ScrollTrigger);

// gsap.to(".display_img img", {
//     scale: 0.5,           
//     y: 450,
//  x: 50,                 
//     rotation: 360,     
//     ease: "power2.inOut", 
//     scrollTrigger: {
//         trigger: ".display_sec_wrap", 
//         start: "top top",             
//         endTrigger: ".cta_sec",    
//         end: "center",          
//         scrub: 2,           
//            pin: true,          
//         anticipatePin: 1,      
//     }
// });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-scroll-video"] && !window.DesignMode) return;
  try {
    
    const video = document.querySelector(".video-background");
    let src = video.currentSrc || video.src;
    // console.log(video, src);


    function once(el, event, fn, opts) {
    var onceFn = function (e) {
        el.removeEventListener(event, onceFn);
        fn.apply(this, arguments);
    };
    el.addEventListener(event, onceFn, opts);
    return onceFn;
    }

    once(document.documentElement, "touchstart", function (e) {
    video.play();
    video.pause();
    });


  gsap.registerPlugin(ScrollTrigger);

  let tl = gsap.timeline({
    defaults: { duration: 1 },
    scrollTrigger: {
      trigger: "#vid_wrap",
      start: "top",
       end: "+=" + (window.innerHeight * 3),
      scrub:3,
ease: "power4",
      pin: true,
    }
  });

  once(video, "loadedmetadata", () => {
    tl.fromTo(
      video,
      {
        currentTime: 0
      },
      {
        currentTime: video.duration || 1
      }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parrallax-with-text"] && !window.DesignMode) return;
  try {
    

   const parallaxContainer = document.querySelector('.parallax-container');
    const parallaxImage = document.querySelector('.parallax-image');
    
    parallaxContainer.addEventListener('mousemove', (e) => {
      const { offsetX, offsetY } = e;
      const { clientWidth, clientHeight } = parallaxContainer;
    
      // Calculate the percentage of the mouse position within the container
      const xPos = (offsetX / clientWidth) - 0.5;
      const yPos = (offsetY / clientHeight) - 0.5;
    
      // Move the image based on the mouse position
      const moveX = xPos * 30; // Adjust this value for more or less movement
      const moveY = yPos * 30;
    
      parallaxImage.style.transform = `translate(${moveX}px, ${moveY}px)`;
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slick_slider"] && !window.DesignMode) return;
  try {
    
      $(document).ready(function(){
        $('.multiple-items').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrow:true,
centerMode: true,
centerPadding: '0px'

});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-boxes"] && !window.DesignMode) return;
  try {
    
   $(document).ready(function() {
                const video = $('#batteryVideo');
                const videoSection = $('#videoCenter_sec');
    
                $(window).on('scroll', function() {
                    const scrollTop = $(this).scrollTop();
                    const sectionTop = videoSection.offset().top;
                    const sectionBottom = sectionTop + videoSection.outerHeight();
                    
                    // Check if the section is in view
                    if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
                        video.get(0).play(); 
                    } else if (scrollTop < sectionTop || scrollTop > sectionBottom) {
                        video.get(0).pause(); 
                        video.get(0).currentTime = 0;
                    }
                });
            });

  } catch(e) { console.error(e); }
})();
})();
